import Batches from "pages/dashboard/shared/Batches/Batches";
import React from "react";

const StudentBatches = () => {
  return <Batches fromStudents={true} />;
};

export default StudentBatches;
